import Image from 'next/image';
import { Wrapper, Feature } from './FeaturesList.styles';
import Link from '@components/common/Link';

export default function FeaturesList() {
  return (
    <Wrapper>
      <Feature>
        <Image src="/home/tokenized.svg" alt="" width={40} height={40} />
        <h4>Tokenized Positions</h4>
        <p>Positions are tradable as an NFT without unwinding your leverage</p>
        <p>
          <Link variant="thick" href="https://opensea.io/collection/archimedespositiontoken-v2" target="_blank">
            OpenSea
          </Link>
        </p>
      </Feature>
      <Feature>
        <Image src="/home/opensource.svg" alt="" width={40} height={40} />
        <h4>Open Source &amp; Audited</h4>
        <p>As a fully doxxed team, we are open and transparent with our community</p>
        <p>
          <Link variant="thick" href="https://github.com/thisisarchimedes/Archimedes_Finance" target="_blank">
            GitHub
          </Link>
        </p>
      </Feature>
      <Feature>
        <Image src="/home/tokenomics.svg" alt="" width={40} height={40} />
        <h4>Superior Tokenomics</h4>
        <p>Yield-bearing stablecoin strategies as base assets, actively managed to keep APY high</p>
        <p>
          <Link variant="thick" href="https://docs.archimedesfi.com/" target="_blank">
            User Docs
          </Link>
        </p>
      </Feature>
      <Feature>
        <Image src="/home/stability.svg" alt="" width={40} height={40} />
        <h4>True Stability</h4>
        <p>
          Positions are over collateralized with battle tested stablecoins. Yield-bearing stablecoin strategies keep APY
          high
        </p>
        <p>
          <Link variant="thick" href="https://docs.archimedesfi.com/archimedes-finance-whitepaper-(v2)" target="_blank">
            Whitepaper
          </Link>
        </p>
      </Feature>
    </Wrapper>
  );
}
